import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/drop-off-sports-gear-storage.jpg'),
    alt: 'drop off sports gear storage page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'drop off sports gear storage page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Convenient <span>Drop-off</span> <span>For Sport Gear Storage</span>',
  description:
    'Is your closet cluttered with sports equipment? ShipAndStorage offers convenient and secure storage for your gear during the off-season. ',
  image: {
    url: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/hero-image.jpg',
    alt: 'Convenient Drop-off For Sport Gear Storage'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Drop Off Your Sports Gear' }
}

export const whyWeSectionContent = {
  title: 'How Drop Off The Storage for Sport Gear Works',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Start Storing Today' },

  cards: [
    {
      id: 1,
      title: 'Prepare Your Gear',
      description: 'Clean and pack your equipment securely to protect it during storage.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/prepare-your-gear.svg',
        alt: 'Prepare Your Gear'
      }
    },
    {
      id: 2,
      title: 'Generate a Label',
      description: 'Create a shipping label for your gear on our website for easy identification.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/generate-a-label.svg',
        alt: 'Generate a Label'
      }
    },
    {
      id: 3,
      title: 'Visit a Drop-off Location',
      description: 'Bring your gear to one of our convenient locations in Delaware or Manhattan.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/visit-a-drop-off-location.svg',
        alt: 'Visit a Drop-off Location'
      }
    },
    {
      id: 4,
      title: 'Store and Relax',
      description: 'Leave your gear in our hands and enjoy your newly organized space.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/store-and-relax.svg',
        alt: 'Store and Relax'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Drop-off Solutions for Storing Sport Gear',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Storage Solutions',
          description: 'Ideal for skis, bikes, golf clubs, and more to meet all your storage needs.'
        },
        {
          id: 2,
          title: 'Convenient Drop-Off Locations',
          description: 'Two accessible sites in Delaware and Manhattan, New York for easy access.'
        },
        {
          id: 3,
          title: 'Hassle-Free Service',
          description: 'Protect your sports equipment while keeping your space organized with our seamless process.'
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/drop-off-solutions-for-storing-sport-gear.jpg',
        alt: 'Drop-off Solutions for Storing Sport Gear'
      }
    }
  ]
}

export const whyChooseShipAndStorageSectionContent = {
  title: 'Why Choose ShipAndStorage for Sports Gear Storage?',

  cards: [
    {
      id: 1,
      title: 'Accessible Locations',
      description:
        'Our drop-off points in Delaware and Manhattan are conveniently located to serve you, making it easy to store your sports gear.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/accessible-locations.svg',
        alt: 'Accessible Locations'
      }
    },
    {
      id: 2,
      title: 'Protective Storage Environment',
      description:
        'Our climate-controlled storage facilities keep your gear in excellent condition, protecting it from moisture and temperature damage.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/protective-storage-environment.svg',
        alt: 'Protective Storage Environment'
      }
    },
    {
      id: 3,
      title: 'Affordable Pricing',
      description:
        'Enjoy competitive rates that fit your budget, whether you need short-term or long-term storage for your equipment.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/affordable-pricing.svg',
        alt: 'Affordable Pricing'
      }
    },
    {
      id: 4,
      title: 'Flexible Storage Options',
      description: 'We provide customizable storage plans to accommodate seasonal sports or extended off-seasons.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/flexible-storage-options.svg',
        alt: 'Flexible Storage Options'
      }
    }
  ]
}

export const serviceTipsSectionContent = {
  title: 'Packing Tips for Sport Gear Storage',

  cards: [
    {
      id: 1,
      title: 'Clean Your Equipment Thoroughly',
      description: 'Remove dirt, debris, or moisture from your gear to prevent damage or corrosion during storage.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/clean-your-equipment-thoroughly.svg',
        alt: 'Clean Your Equipment Thoroughly'
      }
    },
    {
      id: 2,
      title: 'Use Sturdy Storage Bags',
      description: 'Invest in durable bags or cases to keep your equipment safe from dust and scratches.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/use-sturdy-storage-bags.svg',
        alt: 'Use Sturdy Storage Bags'
      }
    },
    {
      id: 3,
      title: 'Disassemble Larger Items',
      description: 'Take apart items like bicycles or gym equipment to save space and reduce the risk of damage.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/disassemble-larger-items.svg',
        alt: 'Disassemble Larger Items'
      }
    },
    {
      id: 4,
      title: 'Wrap Fragile Components',
      description: 'Protect delicate parts with bubble wrap or foam to prevent cracks or breakage.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/wrap-fragile-components.svg',
        alt: 'Wrap Fragile Components'
      }
    },
    {
      id: 5,
      title: 'Label Everything Clearly',
      description: 'Use tags or labels to identify each piece of gear, making retrieval easy and efficient.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/label-everything-clearly.svg',
        alt: 'Label Everything Clearly'
      }
    },
    {
      id: 6,
      title: 'Store Accessories Separately',
      description: 'Keep small accessories like balls, pads, or gloves in separate bags to avoid misplacing them.',
      image: {
        src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/store-accessories-separately.svg',
        alt: 'Store Accessories Separately'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Drop-off Your Sport Gear for Storage',
  description:
    'Drop off your sport gear for storage at our facility. Ideal for golfers, skiers, and snowboarders who need secure storage solutions.',
  image: {
    src: '/images/v2/pages/main-pages/drop-off-sports-gear-storage/promotional-banner-image.png',
    alt: 'Drop-off Your Sport Gear for Storage'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Secure Your Space Today' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'What types of sports gear can I store?',
      answer: 'We store a wide range of sports equipment, including skis, snowboards, bikes, golf clubs, and more.'
    },
    {
      id: 2,
      question: 'Is there a weight or size limit for sports gear storage?',
      answer: 'While we can accommodate most items, please contact us if your gear exceeds standard sizes.'
    },
    {
      id: 3,
      question: 'How do I retrieve my gear from storage?',
      answer: 'Simply contact us to schedule a pickup or visit the drop-off location to retrieve your items.'
    },
    {
      id: 4,
      question: 'Are there any items that cannot be stored?',
      answer: 'We do not accept hazardous materials, perishable items, or flammable substances.'
    },
    {
      id: 5,
      question: 'What happens if I need my gear earlier than planned?',
      answer: 'You can request early access to your gear by contacting us to arrange a convenient pickup.'
    }
  ]
}
